export default {"src":"/_next/static/media/csforall.94e8a57f.ico","height":256,"width":256,"blurWidth":0,"blurHeight":0};